import React from 'react';

import icon from '../generated-icons';

export type CustomerContactAtFinn = {
    email: string;
    name?: string;
    phone?: string;
};

export type ContactProps = {
    customerContactAtFinn?: CustomerContactAtFinn;
};

export default function Contact({
    customerContactAtFinn,
}: ContactProps = {}): React.ReactElement {
    return (
        <div className="m-16 p-16 border-2 border-bluegray-300 rounded-8">
            <div>
                <h4 className="font-bold">Trenger du hjelp?</h4>
                <div className="text-12">
                    <a
                        href="https://hjelpesenter.finn.no/hc/no/articles/360006999100-Nytt-bedriftssenter"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Ofte stilte spørsmål om bedriftssenteret
                    </a>
                </div>
                <div className="text-12 mt-4">
                    <a
                        href="https://hjelpesenter.finn.no/hc/no/articles/115004548985-Hvor-kan-jeg-sende-sp%C3%B8rsm%C3%A5l-om-faktura-"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Spørsmål om faktura og betaling
                    </a>
                </div>
                <div className="text-12 flex gap-16 mt-8">
                    <div
                        dangerouslySetInnerHTML={{ __html: icon.illustration }}
                    />
                    <div>
                        <h4 className="font-bold mb-0">Kundeservice</h4>
                        <div>
                            <a className="link" href="mailto:bedrift@finn.no">
                                bedrift@finn.no
                            </a>
                        </div>
                        <div>22 86 44 10</div>
                        <div>Mandag - fredag: 9 - 16</div>
                    </div>
                </div>
            </div>
            {customerContactAtFinn && customerContactAtFinn.email && (
                <div className="text-12 flex gap-16 mt-8">
                    <div
                        dangerouslySetInnerHTML={{ __html: icon.illustration2 }}
                    />
                    <div>
                        <h4 className="font-bold mb-0">Rådgivning og tips</h4>
                        {customerContactAtFinn.name && (
                            <div>{customerContactAtFinn.name}</div>
                        )}
                        {customerContactAtFinn.email && (
                            <div>
                                <a
                                    href={`mailto:${customerContactAtFinn.email}`}
                                >
                                    {customerContactAtFinn.email}
                                </a>
                            </div>
                        )}
                    </div>
                </div>
            )}
        </div>
    );
}
